// Styling imports.
import 'platform/polyfills';
import './sass/index.scss';

import App from './containers/App';

export default {
  App,
};
